import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useSearchParams } from 'react-router-dom';
import { fetchExecutions } from '../slices/executionSlice';
import { HiOutlineCheckCircle, HiOutlineXCircle, HiOutlineClock, HiOutlineArrowRight, HiOutlineFilter } from 'react-icons/hi';



export default function Executions() {
  const dispatch = useDispatch();
  const { list, loading } = useSelector((s) => s.executions);

  useEffect(() => {
    dispatch(fetchExecutions());

    const intervalId = window.setInterval(() => {
      dispatch(fetchExecutions());
    }, 10000);

    return () => window.clearInterval(intervalId);
  }, [dispatch]);

  const statusIcon = (status) => {
    if (status === 'success') return <HiOutlineCheckCircle className="text-green-500" size={18} />;
    if (status === 'error') return <HiOutlineXCircle className="text-red-500" size={18} />;
    return <HiOutlineClock className="text-yellow-500 animate-pulse" size={18} />;
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="w-8 h-8 border-4 border-brand-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <div className="animate-fade-in max-w-5xl space-y-6">
      <div>
        <h1 className="text-2xl font-bold">Execution Logs</h1>
        <p className="text-gray-500 dark:text-gray-400 text-sm mt-1">History of all scenario executions. Auto-refreshes every 10 seconds.</p>
      </div>

      {list.length === 0 ? (
        <div className="text-center py-16 bg-white dark:bg-gray-900 rounded-xl border border-gray-200 dark:border-gray-800">
          <HiOutlineClock size={40} className="mx-auto mb-3 text-gray-300 dark:text-gray-600" />
          <p className="text-gray-500 dark:text-gray-400">No executions yet.</p>
        </div>
      ) : (
        <div className="bg-white dark:bg-gray-900 rounded-xl border border-gray-200 dark:border-gray-800 divide-y divide-gray-100 dark:divide-gray-800">
          {list.map((exec) => (
            <Link
              key={exec._id}
              to={`/executions/${exec._id}`}
              className="flex items-center gap-3 px-5 py-4 hover:bg-gray-50 dark:hover:bg-gray-800/50 transition-colors"
            >
              {statusIcon(exec.status)}
              <div className="flex-1 min-w-0">
                <div className="text-sm font-medium truncate">{exec.scenarioId?.name || exec.scenarioId}</div>
                <div className="text-xs text-gray-500 dark:text-gray-400">
                  {new Date(exec.createdAt).toLocaleString()}
                </div>
              </div>
              <span className={`text-xs font-medium px-2.5 py-1 rounded-full ${
                exec.status === 'success' ? 'bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-400'
                : exec.status === 'error' ? 'bg-red-100 dark:bg-red-900/30 text-red-700 dark:text-red-400'
                : 'bg-yellow-100 dark:bg-yellow-900/30 text-yellow-700 dark:text-yellow-400'
              }`}>
                {exec.status}
              </span>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
